const QUERY_LINK_KEYS = [
  'COMPARE',
  'FIELD_NAME',
  'MAPNAME',
  'QUOTE_DATA',
  'RECORD_TYPE',
  'TABLE_NAME',
  'VALUE',
];

export function formatQueryLinkEntry(entry) {
  if (!entry || typeof entry !== 'object') return entry;

  const raw = {
    TABLE_NAME: entry.TABLE_NAME,
    FIELD_NAME: entry.FIELD_NAME,
    COMPARE: entry.COMPARE ?? '=',
    RECORD_TYPE: entry.RECORD_TYPE || entry.RECORD_NAME,
    MAPNAME: entry.MAPNAME,
    VALUE: entry.VALUE,
    QUOTE_DATA: entry.QUOTE_DATA,
  };

  const formatted = {};
  QUERY_LINK_KEYS.forEach((key) => {
    let value = raw[key];
    if (key === 'QUOTE_DATA') {
      if (value === true || value === 'TRUE') value = 'TRUE';
      else if (value === false || value === 'FALSE') value = 'FALSE';
      else return;
    }
    if (value === undefined || value === null || value === '') return;
    formatted[key] = value;
  });

  if (!formatted.COMPARE) {
    formatted.COMPARE = '=';
  }

  return formatted;
}

export function formatQueryLinkArray(entries) {
  if (!Array.isArray(entries)) return entries;
  return entries.map(formatQueryLinkEntry);
}
